import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Life.css";

const lifeItems = [
  {
    image: "1. pitha udsob 2.JPG",
    date: "June 24, 2025",
    title: "Pitha-Pulir Utsob",
  },
  {
    image: "7. Footbal Celebration2 1-25.JPG",
    date: "June 29, 2025",
    title: "Footbal Celebration",
  },
  {
    image: "DSC01228.JPG",
    date: "June 20, 2025",
    title: "Class",
  },
];

export default function Life() {
  const navigate = useNavigate();

  const handlePhotoClick = () => {
    navigate("/gallery/photos");
  };

  return (
    <section className="life-section" id="events">
      <div className="life-container">
        {/* Heading */}
        <h2>School Events</h2>

        {/* Grid Layout */}
        <div className="life-grid">
          {lifeItems.map((item, idx) => (
            <div
              className="life-card"
              key={idx}
              onClick={handlePhotoClick}
              style={{ cursor: "pointer" }}
            >
              <div className="life-thumbnail">
                <img
                  src={require(`../Assets/Images/${item.image}`)}
                  alt={item.title}
                />
              </div>
              <div className="life-content">
                <p className="life-date">{item.date}</p>
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* More Button */}
        <div className="life-more">
          <button onClick={() => navigate("/gallery/photos")}>More</button>
        </div>
      </div>
    </section>
  );
}
